import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../auth/useAuthStore';
import './WaylineEntryPage.css';

// ─── Módulos del sistema ───────────────────────────────────────────────────────

const MODULES = [
  { key: 'territorio', label: 'Territorio' },
  { key: 'relevamiento', label: 'Relevamiento' },
  { key: 'inventario', label: 'Inventario' },
  { key: 'analisis', label: 'Análisis' },
  { key: 'escenarios', label: 'Escenarios' },
  { key: 'operaciones', label: 'Operaciones' },
] as const;

function ModuleGrid(): JSX.Element {
  return (
    <ul className="we-modules" aria-label="Módulos de la plataforma">
      {MODULES.map(m => (
        <li key={m.key} className="we-module-item">
          {m.label}
        </li>
      ))}
    </ul>
  );
}

// ─── Backdrop territorial ─────────────────────────────────────────────────────

function EntryBackdrop(): JSX.Element {
  return (
    <div className="we-backdrop" aria-hidden="true">
      <svg
        className="we-backdrop-svg"
        viewBox="0 0 1440 900"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g className="we-net-edges">
          <line x1="180" y1="80" x2="340" y2="260" />
          <line x1="180" y1="80" x2="620" y2="65" />
          <line x1="620" y1="65" x2="700" y2="230" />
          <line x1="620" y1="65" x2="1100" y2="90" />
          <line x1="1100" y1="90" x2="1300" y2="265" />
          <line x1="1380" y1="75" x2="1300" y2="265" />
          <line x1="340" y1="260" x2="480" y2="420" />
          <line x1="340" y1="260" x2="700" y2="230" />
          <line x1="700" y1="230" x2="720" y2="450" />
          <line x1="700" y1="230" x2="1020" y2="250" />
          <line x1="1020" y1="250" x2="960" y2="430" />
          <line x1="1300" y1="265" x2="960" y2="430" />
          <line x1="480" y1="420" x2="380" y2="650" />
          <line x1="480" y1="420" x2="720" y2="450" />
          <line x1="720" y1="450" x2="660" y2="620" />
          <line x1="720" y1="450" x2="960" y2="430" />
          <line x1="960" y1="430" x2="900" y2="645" />
          <line x1="960" y1="430" x2="1160" y2="635" />
          <line x1="660" y1="620" x2="900" y2="645" />
          <line x1="900" y1="645" x2="1160" y2="635" />
          <line x1="80" y1="240" x2="340" y2="260" />
          <line x1="200" y1="440" x2="380" y2="650" />
        </g>
        <g className="we-net-nodes">
          <circle cx="180" cy="80" r="2.5" />
          <circle cx="620" cy="65" r="3.5" className="we-net-node--key" />
          <circle cx="1100" cy="90" r="2.5" />
          <circle cx="80" cy="240" r="2.5" />
          <circle cx="340" cy="260" r="3.5" className="we-net-node--key" />
          <circle cx="700" cy="230" r="4.5" className="we-net-node--hub" />
          <circle cx="480" cy="420" r="3.5" className="we-net-node--key" />
          <circle cx="720" cy="450" r="4.5" className="we-net-node--hub" />
          <circle cx="960" cy="430" r="3.5" className="we-net-node--key" />
          <circle cx="900" cy="645" r="4.5" className="we-net-node--hub" />
        </g>
      </svg>
    </div>
  );
}

// ─── Botón de acceso sensible al rol ─────────────────────────────────────────

function EntryButton(): JSX.Element {
  const { isAuthenticated, isLoading, token, user } = useAuthStore();
  const navigate = useNavigate();

  function resolveDestination(): string {
    if (!isAuthenticated || !user) return '/login';
    const isSuperAdmin = user.role.name === 'superadmin';
    return isSuperAdmin ? '/admin/overview' : '/territorio';
  }

  if (token && (isLoading || !user)) return <></>;

  return (
    <button type="button" className="we-cta" onClick={() => navigate(resolveDestination())}>
      Ingresar
    </button>
  );
}

// ─── Entrada institucional de Westeer ─────────────────────────────────────────

export function WaylineEntryPage(): JSX.Element {
  return (
    <div className="we-layout">
      <EntryBackdrop />

      <div className="we-overlay" aria-hidden="true" />

      <div className="we-content">
        <div className="we-brand">
          <img
            src="/images/wayline-isotipo.svg"
            alt=""
            aria-hidden="true"
            className="we-brand-mark"
          />
          <span className="we-brand-name">WAYLINE</span>
        </div>

        <div className="we-identity">
          <h1 className="we-claim">
            Líneas claras para territorios complejos.
          </h1>
          <p className="we-description">
            Wayline integra datos territoriales, movilidad e infraestructura urbana para orientar
            decisiones públicas con mayor claridad.
          </p>
        </div>

        <ModuleGrid />

        <div className="we-actions">
          <EntryButton />
        </div>
      </div>
    </div>
  );
}
